import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { Customer, WorkExperience } from '../../../../core/api/models';
import 'react-widgets/dist/css/react-widgets.css';
import WorkExperienceForm from './WorkExperienceForm';
import api from '../../../../api';

const Experience: React.FunctionComponent<{
  updateUser: () => void;
  customerDetails?: Customer;
  canUpdateCustomerExperiences?: boolean;
  fields: { displayName: string; value: string; type: string; group: string }[];
}> = (props) => {
  const [isShowForm, setShowForm] = useState<boolean>(true);

  const onReset = async () => {
    try {
      await api.lead.resetWorkExperiences(props.customerDetails?._id);
      toastr.success('Success', 'Work Experiences reset successfully');
      props.updateUser();
    } catch (error) {
      toastr.error('Error', error?.response?.data?.message);
    }
  };

  const onSubmit = async (data: WorkExperience) => {
    const workDetails: WorkExperience = {
      jobTitle: data.jobTitle,
      employmentType: data.employmentType,
      companyName: data.companyName,
      businessType: data.businessType,
      location: data.location,
      isCurrentEmployer: data.isCurrentEmployer,
      startDate: data.startDate,
    };
    if (!data.isCurrentEmployer) {
      workDetails.endDate = data.endDate;
    }

    const updateData: Customer = {
      workDetails: [workDetails],
    };
    try {
      await api.lead.updateWorkExperiences(
        updateData,
        props.customerDetails?._id
      );
      toastr.success('Success', 'Work Experiences saved successfully');
      props.updateUser();
    } catch (error) {
      toastr.error('Error', error?.response?.data?.message);
    }
  };

  return (
    <div className="p-4 accordion__body border-bottom">
      {isShowForm ? (
        <WorkExperienceForm
          onSubmit={(data) => onSubmit(data)}
          onReset={() => onReset()}
          customerDetails={props.customerDetails}
          canUpdateCustomerExperiences={props.canUpdateCustomerExperiences}
          fields={props.fields}
        ></WorkExperienceForm>
      ) : (
        <>
          {props.canUpdateCustomerExperiences && (
            <button
              onClick={() => setShowForm(true)}
              className="btn btn-link font-sm p-0 font-weight-semibold mb-3 mt-1"
            >
              + add Work Experience
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default Experience;
